module.exports = __webpack_public_path__ + "img/dacy.fe896e5c.png";